import htLogo from "../../imagenes/htLogoNaranja.png";


export default function Home(){
    
    
    return (
        <div className='container w-screen bg-gray-900 justify-center'>             
            <div className='flex m-8 text-orange-500 font-bold pt-14 justify-center'>
                <img className='w-[300px] h-[300px]' src={htLogo}/>
            </div>
        </div>
    )
}